import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
import { PlaceVariables, PlaceArgs } from './queryVariables/place';
export class PlaceResource extends EntityResource {
    constructor() {
        super({
            entityName: 'place',
            addMutationName: 'placeAdd'
        });
        this.getFields = {
            id: true,
            name: true,
            city: true,
            postalCode: true,
            street: true,
            homeNumber: true,
            localNumber: true,
            description: true,
            descriptionShort: true,
            images: true,
            mainImage: true,
            lat: true,
            lng: true
        };
        this.listFields = {
            id: true,
            name: true,
            street: true,
            postalCode: true,
            homeNumber: true,
            localNumber: true,
            city: true,
            descriptionShort: true,
            images: true,
            mainImage: true,
            phoneNumber: true
        };
        this.addVariables = { partnerId: 'Int!', ...PlaceVariables };
        this.addArgs = {
            partnerId: new VariableType('partnerId'),
            ...PlaceArgs
        };
        this.updateVariables = { id: 'Int!', ...PlaceVariables };
        this.updateArgs = { id: new VariableType('id'), ...PlaceArgs };
        this.listVariables = { filters: 'FiltersWithPartnerId' };
    }
}
export const placeResource = new PlaceResource();
//# sourceMappingURL=place.resource.js.map